// src/services/groupService.js
import api from "./api";

/** Util: extrai o ID do grupo de um objeto (group_id ou groupId) */
function getGroupIdFrom(data) {
  return data?.group_id ?? data?.groupId ?? null;
}

// --- CRUD de Grupos ---

// Não paginada (equivalente a fetchAuthors)
export function fetchGroups() {
  return api.get("/groups");
}

export function getGroupById(id) {
  return api.get(`/groups/${id}`);
}

/**
 * Busca um grupo pelo nome exato. Endpoint público (sem [Authorize]) — usado
 * pelo cadastro de usuário para resolver o grupo "Todos" antes de existir
 * uma sessão autenticada, já que GET /groups exige login e é filtrado por
 * círculo.
 */
export function getGroupByName(groupName) {
  return api.get(`/groups/by-name/${encodeURIComponent(groupName)}`);
}

export function createGroup(data) {
  return api.post("/groups", data);
}

/**
 * Update alinhado ao store: updateGroup(data)
 * O ID deve estar em data.group_id ou data.groupId.
 */
export function updateGroup(data) {
  const id = getGroupIdFrom(data);
  if (id == null) {
    throw new Error(
      "updateGroup: ID do grupo ausente em data (group_id/groupId)."
    );
  }
  return api.put(`/groups/${id}`, data);
}

export function deleteGroup(id) {
  return api.delete(`/groups/${id}`);
}

/** Exclusão em lote: envia o array de IDs no corpo da requisição */
export function deleteGroupsBatch(ids) {
  return api.delete("/groups", {
    data: ids, // array de IDs
  });
}

/** Paginada (equivalente a fetchAuthorsPaged) */
export function fetchGroupsPaged(pageNumber, pageSize, search = "") {
  return api.get("/groups/paged", {
    params: { pageNumber, pageSize, search },
  });
}

// --- Gerenciamento de Relação Usuário-Grupo (user_group) a partir da perspectiva do Grupo ---

/** Lista usuários de um grupo específico */
export function fetchUsersInGroup(groupId) {
  return api.get(`/groups/${groupId}/users`);
}

/** Adiciona usuário ao grupo */
export function addUserToGroup(groupId, userId) {
  return api.post(`/groups/${groupId}/users/${userId}`);
}

/** Remove usuário do grupo */
export function removeUserFromGroupViaGroup(groupId, userId) {
  return api.delete(`/groups/${groupId}/users/${userId}`);
}
